import type { RouteRecordRaw } from 'vue-router'

export const notificationsRoutes: RouteRecordRaw[] = [
  {
    path: '/notifications',
    name: 'NOTIFICATIONS',
    component: () => import('./NotificationsPage.vue'),
    meta: { requiresAuth: true },
  },
]
